import { render, staticRenderFns } from "./NippouItemComponent.vue?vue&type=template&id=564b3d41&"
import script from "./NippouItemComponent.vue?vue&type=script&lang=js&"
export * from "./NippouItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports